import storage from 'redux-persist/lib/storage';

export const persistConfig = {
    key: 'root',
    storage,
    whitelist: [] // persist only what you need state to store in local storage
};
